import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, PagingResponseModel } from '../../shared';
import {
  CfpProgramMemberQueryCriteriaClass,
  CfpProgramMemberCriteriaModelQuery
} from '../../../criteria/cfp-program-member-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class CfpProgramMemberService extends BaseApiTemplateService<any> {

  static readonly CFP_PROGRAM_MEMBER_SUBPATH = Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'cfp/program-members/';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpProgramMemberService.CFP_PROGRAM_MEMBER_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpProgramMemberService.CFP_PROGRAM_MEMBER_SUBPATH +
      BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  public getByCriteriaBackofficeEp(
    visa: ApiVisa,
    criteria?: CfpProgramMemberQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpProgramMemberCriteriaModelQuery(criteria);
    const url = (visa.api_domain_url ? visa.api_domain_url + this.endpoint_path : this.apiUrl)
      + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEp(
    visa: ApiVisa,
    criteria?: CfpProgramMemberQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpProgramMemberCriteriaModelQuery(criteria);
    const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url
      ? visa.api_domain_url + this.endpoint_path_login_url
      : this.apiUrl;
    const url = loginApiUrl + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }
}
